import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c50e587"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-4 container" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-arrow-left" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"5px"} }, "Salvar", -1))
const _hoisted_7 = { class: "d-flex flex-row gap-4" }
const _hoisted_8 = { class: "d-flex flex-column gap-4 col-8 card p-4" }
const _hoisted_9 = { class: "d-flex flex-row gap-2" }
const _hoisted_10 = { class: "d-flex flex-column gap-1 col-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Titulo do form", -1))
const _hoisted_12 = { class: "d-flex flex-column gap-1 col-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Categoria", -1))
const _hoisted_14 = { class: "d-flex flex-row gap-2" }
const _hoisted_15 = { class: "d-flex flex-column gap-1 col-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Quadro Jira", -1))
const _hoisted_17 = { class: "d-flex flex-column gap-1 col-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tipo de issue/card", -1))
const _hoisted_19 = {
  key: 0,
  class: "d-flex flex-row col-12 gap-2"
}
const _hoisted_20 = { class: "d-flex flex-column gap-1 col-6" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nome do campo:", -1))
const _hoisted_22 = { class: "d-flex flex-column gap-1" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tipo do campo", -1))
const _hoisted_24 = {
  key: 1,
  class: "d-flex flex-row col-12 gap-2"
}
const _hoisted_25 = { class: "d-flex flex-column gap-1 col-6" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nome do campo:", -1))
const _hoisted_27 = { class: "d-flex flex-column gap-1" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tipo do campo", -1))
const _hoisted_29 = {
  key: 2,
  class: "d-flex flex-row col-12 gap-2"
}
const _hoisted_30 = { class: "d-flex flex-column gap-1 col-6" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nome do campo:", -1))
const _hoisted_32 = { class: "d-flex flex-column gap-1" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tipo do campo", -1))
const _hoisted_34 = { class: "d-flex flex-row col-12 gap-2" }
const _hoisted_35 = { class: "d-flex flex-column gap-1 col-6" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Status:", -1))
const _hoisted_37 = { class: "d-flex flex-column gap-1" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tipo do campo", -1))
const _hoisted_39 = { class: "d-flex flex-row" }
const _hoisted_40 = { class: "col card p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Title, { description: "Os campos TÍTULO e DESCRIÇÃO ja existem por padrão, não precisa adiciona-los" }, {
        default: _withCtx(() => [
          _createTextVNode("Cadastrar form de criação de ticket")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          variant: "secondary",
          style: {"min-width":"fit-content"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('listaTickets')))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          variant: "secondary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitForm(_ctx.formRef)))
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_el_input, {
              modelValue: _ctx.dynamicForm.titulo,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dynamicForm.titulo) = $event)),
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_el_select, {
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.findForm())),
              modelValue: _ctx.selectedCategory,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCategory) = $event)),
              placeholder: "Defina a categoria"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayCategory, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_el_select, {
              modelValue: _ctx.jiraOptions.key,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.jiraOptions.key) = $event)),
              placeholder: "Defina o quadro",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projetos, (proj, key) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (_ctx.nameProject && proj.name.toLowerCase().includes(_ctx.nameProject.toLowerCase()))
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          value: proj.key,
                          key: key
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(proj.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_el_select, {
              modelValue: _ctx.jiraOptions.tipo,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.jiraOptions.tipo) = $event)),
              placeholder: "Escolha a issue",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_ctx.jiraOptions.key !== 'SGSI' && _ctx.jiraOptions.key !== 'II')
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.issues, (tipo, key) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: key,
                        value: tipo
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tipo), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  : (_openBlock(), _createBlock(_component_el_option, {
                      key: 1,
                      value: "Tarefa"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Tarefa")
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.dynamicForm,
          class: "demo-dynamic"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dynamicForm.campos, (field, index) => {
              return (_openBlock(), _createBlock(_component_el_form_item, {
                key: index,
                id: "listaZebrada",
                class: "p-4 mb-0",
                style: {"position":"relative"}
              }, {
                default: _withCtx(() => [
                  (field.type === 'input')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createTextVNode(),
                          _createVNode(_component_el_input, {
                            modelValue: field.label,
                            "onUpdate:modelValue": ($event: any) => ((field.label) = $event),
                            clearable: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode(_component_el_input, {
                            value: "Texto simples",
                            disabled: ""
                          })
                        ])
                      ]))
                    : (field.type === 'textarea')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _createTextVNode(),
                            _createVNode(_component_el_input, {
                              modelValue: field.label,
                              "onUpdate:modelValue": ($event: any) => ((field.label) = $event),
                              clearable: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createVNode(_component_el_input, {
                              type: "textarea",
                              value: "Esse é um campo de texto descrição",
                              disabled: ""
                            })
                          ])
                        ]))
                      : (field.type === 'date')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _hoisted_31,
                              _createTextVNode(),
                              _createVNode(_component_el_input, {
                                modelValue: field.label,
                                "onUpdate:modelValue": ($event: any) => ((field.label) = $event),
                                clearable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _hoisted_33,
                              _createVNode(_component_el_date_picker, {
                                type: "date",
                                disabled: ""
                              })
                            ])
                          ]))
                        : (field.type === 'select')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                  _hoisted_36,
                                  _createTextVNode(),
                                  _createVNode(_component_el_input, {
                                    value: "Status",
                                    modelValue: field.label,
                                    "onUpdate:modelValue": ($event: any) => ((field.label) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_37, [
                                  _hoisted_38,
                                  _createVNode(_component_el_select, { disabled: "" })
                                ])
                              ]),
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.selectedStatus,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedStatus) = $event)),
                                onChange: ($event: any) => (_ctx.insertOptions(index)),
                                placeholder: "Defina os status",
                                multiple: "",
                                class: "mt-2"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayStatus, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.name,
                                      value: `label: ${item.name}, value: ${item.id}`
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onChange"])
                            ], 64))
                          : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    type: "danger",
                    icon: _ctx.Delete,
                    circle: "",
                    onClick: _withModifiers(($event: any) => (_ctx.removeField(index)), ["prevent"]),
                    id: "btnRemove"
                  }, null, 8, ["icon", "onClick"])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_el_form_item, { class: "mt-2 d-flex flex-row btnGroup" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_el_button, {
                    type: "info",
                    icon: _ctx.Plus,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addField('input')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Texto simples")
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  _createVNode(_component_el_button, {
                    type: "info",
                    icon: _ctx.Plus,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addField('textarea')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Texto descrição")
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  _createVNode(_component_el_button, {
                    type: "info",
                    icon: _ctx.Plus,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addField('date')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Data")
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  _createVNode(_component_el_button, {
                    type: "info",
                    icon: _ctx.Plus,
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addField('select')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Status")
                    ]),
                    _: 1
                  }, 8, ["icon"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("pre", null, _toDisplayString(_ctx.formattedDynamicForm), 1)
      ])
    ])
  ]))
}